import { useCallback, useState } from "react";
import type { Ack, PlayerAction } from "@grundbesitz/shared";
import { useStore } from "../../../lib/store";

/**
 * Sends game intents through the store and remembers which one is in flight,
 * so a button can show "busy" and a double click does not send twice.
 */
export function useAct() {
  const act = useStore((s) => s.act);
  const [busy, setBusy] = useState<string | null>(null);

  const run = useCallback(
    async (key: string, action: PlayerAction, opts?: { skipVersion?: boolean }): Promise<Ack> => {
      setBusy(key);
      try {
        return await act(action, opts);
      } finally {
        setBusy(null);
      }
    },
    [act],
  );

  return { busy, run };
}
